import { IBestellposition } from './IBestellposition';

// SharePoint User/Author field
export interface ISharePointUser {
  Title?: string;
  Email?: string;
  Id?: number;
}

// Bestellung Interface basierend auf Bestellungen.csv
export interface IBestellung {
  id?: string;
  Id?: number; // SharePoint List Item ID (number)
  Title: string;
  AnforderndePersonen: string;
  AnforderndePersonString?: string; // Für Formulare
  Personalnummer: string;
  AnforderndeKostenstelle: string;
  Durchwahl: string;
  HinweistextZurBestellung: string;
  Erstellungsdatum: Date;
  InterneBestellnummer: string;
  IsArchiviert?: boolean; // Gibt an, ob die Bestellung archiviert ist
  Vertraulich?: boolean; // Wenn true: nur Admin, Einkauf, GF, Freigebende und Owner sehen die Bestellung
  AuthorEmail?: string; // Email des Erstellers (DB-Feld)
  AuthorName?: string; // Name des Erstellers (DB-Feld)
  Author?: ISharePointUser; // SharePoint Author field (wer hat erstellt, computed)
}

// Bestellung mit zugehörigen Positionen und berechneten Feldern
export interface IBestellungMitPositionen extends IBestellung {
  Positionen: IBestellposition[];
  // Berechnete/aggregierte Felder
  GesamtSumme: number;
  AnzahlPositionen: number;
  Liefertermin: string;
  Genehmigungsstatus: GenehmigungsstatusAggregiert;
  Bestellstatus: BestellstatusAggregiert;
}

export enum GenehmigungsStatus {
  Freigegeben = "Freigegeben",
  TeilweiseFreigegeben = "Teilweise freigegeben",
  Offen = "Offen",
  Abgelehnt = "Abgelehnt"
}

// Alias für Kompatibilität
export type Genehmigungsstatus = GenehmigungsStatus;

export enum BestellStatus {
  Geliefert = "Geliefert",
  TeilweiseGeliefert = "Teilweise geliefert",
  Bestellt = "Bestellt",
  Eingereicht = "Eingereicht"
}

// Alias für Kompatibilität
export type Bestellstatus = BestellStatus;

// Aggregierte Status-Typen (mit String-Literals für mehr Flexibilität)
export type GenehmigungsstatusAggregiert =
  | GenehmigungsStatus
  | 's. Position'
  | 'Freigegeben'
  | 'Teilweise freigegeben'
  | 'Offen'
  | 'Abgelehnt';

export type BestellstatusAggregiert =
  | BestellStatus
  | 's. Position'
  | 'Geliefert'
  | 'Teilweise geliefert'
  | 'Bestellt'
  | 'Eingereicht';
